import {
	factorWeighingSum,
	getPercentageByValue, getPercentageValue, getSlugify,
	totalSumWeighings,
} from '@/modules/job-evaluation/utils/valuation-model/factors';
import {
	filter,
	findIndex,
	has,
	length,
	map,
	pathOr,
	pick,
	pipe,
	propEq,
	dissoc,
	addIndex,
	find,
	prop,
	head, keys, applySpec,
} from 'ramda';

const mapIndexed = addIndex(map);
const BASE_PG = 1000;

export const getPGM = (factor, combinations) => {
	const totalSum = factorWeighingSum(factor, combinations);
	const totalWeighing = totalSumWeighings(combinations);
	const percentage = getPercentageByValue(totalSum, totalWeighing);
	return getPercentageValue(parseFloat(percentage), BASE_PG);
};

export const getNewDegree = data => ({
	code: null,
	...data,
	uuid: getSlugify(data.name),
});

const toFixed = value => ((Math.round(value) === value) ? value : value.toFixed(2));

export const getPGm = (pgMax, degrees) => toFixed(pgMax / (length(degrees) || 1));

export const assocRate = (pgMax, selectedDegrees, degree) => {
	let rate = 0;
	if (degree.selected) {
		const indexFound = findIndex(propEq('uuid', degree.uuid), selectedDegrees);
		const progressionValue = pgMax / length(selectedDegrees);
		rate = toFixed((indexFound + 1) * progressionValue);
	}
	return {
		...degree,
		rate,
	};
};

const getFactorsWeight = (selectedFactors, combinations, factorDegrees) => map(
	factor => ({
		...pick(['id', 'name'], factor),
		criterionId: null,
		criterionName: null,
		totalWeight: factorWeighingSum(factor, combinations),
		totalGrade: pipe(
			prop(factor.uuid),
			length,
		)(factorDegrees),
		grades: pipe(
			prop(factor.uuid),
			map(applySpec({
				code: prop('uuid'),
				name: prop('name'),
				flagActive: pipe(
					prop('selected'),
					value => (value ? 1 : 0),
				),
				rate: prop('rate'),
			})),
		)(factorDegrees),
		relatedFactorWeights: pipe(
			filter(has(factor.uuid)),
			map(dissoc(factor.uuid)),
			mapIndexed((relatedFactor) => {
				const relatedFactorUuid = head(keys(relatedFactor));
				const factorFound = find(propEq('uuid', relatedFactorUuid), selectedFactors);
				return {
					id: prop('id', factorFound),
					name: prop('name', factorFound),
					weight: prop(relatedFactorUuid, relatedFactor),
					criterionId: 1,
				};
			}),
		)(combinations),
	}),
	selectedFactors,
);

export const parseRequestValuation = (state) => {
	const selectedFactors = pathOr([], ['supplies', 'valuationModel', 'selectedFactors'], state);
	const combinations = pathOr([], ['supplies', 'valuationModel', 'weighing', 'combinations'], state);
	const factorDegrees = pathOr([], ['supplies', 'valuationModel', 'degree', 'factorDegrees'], state);
	return {
		name: 'Nombre de la encuesta 001',
		toolCode: 'JEV',
		languages: {
			SPA: { name: 'Nombre de la encuesta 001' },
			ENG: { name: 'Poll name 001' },
			FRA: { name: 'Nom du sondage 001' },
		},
		stageStatus: 1,
		stageDetailStatus: 3,
		factorsWeight: getFactorsWeight(selectedFactors, combinations, factorDegrees),
	};
};

export default {};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/utils/valuation-model/degree.js